import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { getFormValues } from "redux-form";
import * as adminActions from "../../../../../actions/admin.actions";
import * as dropdownsActions from "../../../../../actions/dropdowns.actions";
import * as projectActions from "../../../../../actions/project.actions";
import * as skillsActions from "../../../../../actions/skills.actions";
import * as citiesActions from "../../../../../actions/cities.actions";
import EditProjectDetail from "../components/EditProjectDetail";

class EditProjectDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.adminActions.getProject(
      this.props.match.params.projectId,
      "adminProjectDetail"
    );
    this.props.dropdownsActions.getJobTypes();
    this.props.dropdownsActions.getWorkTypes();
    this.props.dropdownsActions.getCompanyBudgets();
    this.props.dropdownsActions.getProjectBudgetRateTypes();
    this.props.skillsActions.fetchSkills();
    this.props.adminActions.getAdminList();
    this.props.projectActions.getStatus();
  }

  handleSubmit(data) {
    const adminEdit = true;
    const loading = true;

    if (data.city && _.isArray(data.city) && data.city.length > 0) {
      localStorage.setItem("projectLocation", JSON.stringify(data.city));
      data.city = data.city[0].description;
    }

    if (!data.budget_run_start) {
      data.budget_run_end = null;
    }

    this.props.projectActions.updateProject(
      data,
      "detail",
      this.props.match.params.projectId,
      adminEdit,
      loading
    );
  }

  render() {
    return (
      <EditProjectDetail
        onSubmit={this.handleSubmit}
        admins={this.props.admins}
        status={this.props.status}
        jobTypes={this.props.jobTypes}
        workTypes={this.props.workTypes}
        cities={this.props.cities}
        onSearchCities={this.props.citiesActions.searchCitiesAutocomplete}
        companyBudgets={this.props.companyBudgets}
        projectBudgetRateTypes={this.props.projectBudgetRateTypes}
        skills={this.props.skills}
        currentCity={_.get(this.props, "project.city")}
        projectId={this.props.match.params.projectId}
        formValues={this.props.formValues || {}}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    admins: state.admin.admins,
    status: state.project.status,
    jobTypes: state.dropdowns.jobTypes.data,
    workTypes: state.dropdowns.workTypes.data,
    cities: state.cities.cities.predictions,
    isLoading: state.cities.cities.isLoading,
    projectBudgetRateTypes: state.dropdowns.projectBudgetRateTypes.data,
    companyBudgets: state.dropdowns.companyBudgets.data,
    skills: state.skills.skills.data,
    project: state.admin.project,
    formValues: getFormValues("adminProjectDetail")(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch),
    citiesActions: bindActionCreators(citiesActions, dispatch),
    skillsActions: bindActionCreators(skillsActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProjectDetailContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/edit/containers/EditProjectDetailContainer.js